export default __webpack_public_path__ + "static/media/vc building.8518e25c.jpg";